<template>
  <div>
    <v-row justify="center">
      <v-col cols="8">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="nombre"
            :rules="nombreReglas"
            label="Nombre"
            required
          ></v-text-field>
          <v-text-field
            v-model="apellido"
            :rules="apellidoReglas"
            label="Apellido"
            required
          ></v-text-field>
          <v-text-field
            v-model="dni"
            :rules="dniReglas"
            label="DNI"
            required
            @keypress="soloNumeros"
          ></v-text-field>
          <v-row class="align-center" justify="center">
            <v-col cols="5">
              <v-text-field
                class="input"
                label="Fecha de Nacimiento"
                placeholder="AAAA-MM-DD"
                v-model="fechaNacimiento"
                required
                v-mask="'####-##-##'"
              ></v-text-field>
            </v-col>
            <v-col cols="7">
              <v-radio-group v-model="sexo" :rules="sexoReglas" row>
                <!-- <v-radio v-for="n in 2" :key="n" :label="`Radio ${n}`" :value="n"></v-radio>-->
                <v-radio label="Masculino" value="m" required></v-radio>
                <v-radio label="Femenino" value="f" required></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-select
            v-model="agrupamientoSeleccionado"
            :items="agrupamientos"
            item-text="descripcion"
            item-value="id"
            :rules="[(v) => !!v || 'Agrupamiento es obligatorio']"
            label="Agrupamiento"
            required
          ></v-select>
          <v-row justify-center>
            <v-col xs6 class="topPadding30 bottomPadding30 text-xs-center">
              <v-btn :disabled="!valid" color="success" @click="validate"
                >Guardar</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import API from "@/components/_config/conf";

export default {
  data() {
    return {
      valid: true,
      //oculatarAgrupamiento: true,
      nombre: "",

      nombreReglas: [
        (v) => !!v || "Nombre es obligatorio",
        //v => (v && v.length <= 10) || "Name must be less than 10 characters"
      ],
      apellido: "",
      apellidoReglas: [
        (v) => !!v || "Apellido es obligatorio",
        //v => (v && v.length <= 10) || "Name must be less than 10 characters"
      ],
      dni: "",
      dniReglas: [
        (v) => !!v || "DNI es obligatorio",
        (v) => (v && v.length >= 7) || "Dni debe tener al menos 7 digitos",
      ],
      fechaNacimiento: "",
      sexo: "",
      sexoReglas: [(v) => !!v || "Debe seleccionar un Sexo"],
      agrupamientos: [],
      agrupamientoSeleccionado: "",
    };
  },
  components: {},
  computed: {},
  mounted: function () {
    this.cargarDatosAlumno();
    this.obtenerAgrupamientos();
  },
  props: ["idalumno", "alumno", "reset"],
  watch: {
    reset: function () {
      this.$refs.form.reset();

      this.obtenerAgrupamientos();

      if (this.reset) {
        if (this.idalumno != -1) {
          this.cargarDatosAlumno();

          //this.oculatarAgrupamiento = true;
        } /* else {
          this.oculatarAgrupamiento = false;
        }*/
      }
    },
  },

  methods: {
    soloNumeros(e) {
      var key = window.event ? e.which : e.keyCode;
      if (key < 48 || key > 57) {
        e.preventDefault();
      }
    },
    validate() {
      if (this.$refs.form.validate()) {
        //console.log("formulario nuevo Alumno valido", this.sexo);

        let params =
          "idAlumno=" +
          this.idalumno +
          "&nombre=" +
          this.nombre +
          "&apellido=" +
          this.apellido +
          "&dni=" +
          this.dni +
          "&fecha_nacimiento=" +
          this.fechaNacimiento +
          "&sexo=" +
          this.sexo +
          "&idAgrupamiento=" +
          this.agrupamientoSeleccionado;

        let resultado = API.enviar("get", "guardarAlumno", params);

        resultado
          .then((result) => {
            if (result.data.msj == "ok") {
              this.$emit("infoGeneral:mostrarOcultarDialog");
              this.$emit("infoGeneral:listarAlumnos");
            }
          })
          .catch((error) => {
            console.log(
              "editarCrearAlumno -> infoGeneral | methods | guardarAlumno |  catch: -> ",
              error
            );
          });
      } else {
        //console.log("formulario nuevo Alumno invalido");
      }
      this.dialog = false;
    },
    obtenerAgrupamientos: function () {
      let resultado = API.enviar("get", "obtenerCursos", "");
      resultado
        .then((result) => {
          if (result.data.msj == "ok") {
            this.agrupamientos = result.data.result;
          }
        })
        .catch((error) => {
          console.log(
            "editarCrearAlumno | methods | obtenerAgrupamientos |  catch: -> ",
            error
          );
        });
    },
    cargarDatosAlumno() {
      console.log("idalumno: ", this.idalumno);
      if (this.idalumno != -1) {
        this.nombre = API.ucFirst(this.alumno.nombre);
        this.apellido = API.ucFirst(this.alumno.apellido);
        this.dni = this.alumno.dni;
        this.fechaNacimiento = this.alumno.fecha_nacimiento;
        this.sexo = this.alumno.sexo;

        this.agrupamientoSeleccionado = this.alumno.idagrupamiento;
      }
    },
  },
};
</script>

<style scoped>
.input {
  padding: 5px !important;
}

.ocultarElemento {
  display: none;
}
</style>